export const version = '12.4.1';
export const buildDate = '2025-04-08T11:56:07.396Z';
export const commitHash = 'be8d6bd';